const { __ } = wp.i18n;
const { PluginDocumentSettingPanel } = wp.editPost;
const { withSelect, select } = wp.data;
const { TextControl } = wp.components;
const { compose } = wp.compose;
const I18N_DOMAIN = 'ib-infobeans';
const EpisodeDuration = ({ meta }) => {
	let metaEpisodeDuration = meta?.episode_duration ? meta?.episode_duration : '';

	const updateMeta = metaKey => value => {
		wp.data.dispatch('core/editor').editPost({
			meta: {
				...meta,
				[metaKey]: value,
			},
		});
	};

	const setEpisodeDuration = e => {
		metaEpisodeDuration = e;
		updateMeta('episode_duration')(metaEpisodeDuration);
	};

	return (
		<PluginDocumentSettingPanel
			name="episode-duration"
			title={__('Episode Duration', I18N_DOMAIN)}
			className="Episode_Duration"
		>
			<>
				{
					<div>
						<div>
							<TextControl
								placeholder={__('Episode Duration', I18N_DOMAIN)}
								onChange={value => setEpisodeDuration(value)}
								value={metaEpisodeDuration}
								type="number"
							/>
						</div>
					</div>
				}
			</>
		</PluginDocumentSettingPanel>
	);
};

export default compose(
	withSelect(() => {
		const meta = select('core/editor').getEditedPostAttribute('meta');
		const currentPost = select('core/editor').getCurrentPost();
		return {
			meta,
			postType: currentPost?.type,
		};
	}),
)(EpisodeDuration);
